import { Typography } from '../../global/theme';

import styled from 'styled-components';

export const IconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  cursor: pointer;
  svg {
    fill: var(--text-secondary);
  }
  :hover {
    background-color: var(--neutral-secondary);
    border-radius: 6px;
    svg {
      fill: var(--text-primary);
    }
  }
`;

export const Dropdiv = styled.div`
  .active-dropdown {
    background-color: var(--neutral-secondary);
    border-radius: 6px;
  }
`;

export const BackArrowIcon = styled.div`
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease-in-out;
`;

export const ProjectLinkEmbedContainer = styled.div`
  display: flex;
  max-width: 300px;
  min-width: 300px;
  padding: 8px 10px;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  border: 0.5px solid var(--border-primary);
  background: var(--background-tertiary);
  justify-content: space-between;
  margin-top: 12px;
  position: relative;
  cursor: pointer;

  &:hover {
    ${BackArrowIcon} {
      opacity: 1;
      visibility: visible;
      cursor: pointer;
    }
  }
`;

export const ProjectContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ProjectName = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;

export const ProjectProgress = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ProjectStatusDot = styled.span<{ $statusColor: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.$statusColor || 'var(--neutral-primary)'};
`;

export const ProjectStatusText = styled.span`
  ${Typography.body_sm}
  color: var(--text-secondary);
`;

export const ProjectDescription = styled.div`
  ${Typography.body_sm}
  color: var(--text-secondary);
`;
